import { render, staticRenderFns } from "./RegistroProspecto.vue?vue&type=template&id=20e72a2c&scoped=true&"
import script from "./RegistroProspecto.vue?vue&type=script&lang=js&"
export * from "./RegistroProspecto.vue?vue&type=script&lang=js&"
import style0 from "./RegistroProspecto.vue?vue&type=style&index=0&id=20e72a2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e72a2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
